import type { ButtonProps } from "@uhg-harmony/react";
export { Button, type ButtonProps } from "@uhg-harmony/react";

const _onPress = () => {};

export const buttonDefaults: ButtonProps = {
  onPress: _onPress,
  size: "m",
  disabled: false,
  block: false,
  inverse: false,
};
